import { useConfirmStore } from '@/stores/confirmStore';
import { useT } from '@/i18n/useI18n';

/** Renders the active confirm dialog (driven by confirmStore). Mount once near
 * the app root, alongside ToastHost. Replaces window.confirm with in-game UI. */
export function ConfirmHost() {
  const t = useT();
  const current = useConfirmStore((s) => s.current);
  const answer = useConfirmStore((s) => s.answer);
  if (!current) return null;

  return (
    <div
      onClick={() => answer(false)}
      style={{
        position: 'fixed', inset: 0, zIndex: 10000,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: 'rgba(2,3,18,0.72)', backdropFilter: 'blur(3px)', padding: 24,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="card"
        style={{ width: '100%', maxWidth: 340, padding: 20, display: 'flex', flexDirection: 'column', gap: 14 }}
      >
        {current.title && <div style={{ fontWeight: 800, fontSize: 16 }}>{current.title}</div>}
        <div style={{ fontSize: 14, color: 'var(--ink)', lineHeight: 1.4 }}>{current.body}</div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button className="btn btn-ghost" style={{ flex: 1 }} onClick={() => answer(false)}>
            {current.cancelLabel ?? t('common.cancel')}
          </button>
          <button
            className="btn btn-primary"
            style={{
              flex: 1,
              ...(current.danger ? { color: 'var(--c-red)', borderColor: 'rgba(230,57,70,0.5)', background: 'rgba(230,57,70,0.12)' } : {}),
            }}
            onClick={() => answer(true)}
          >
            {current.confirmLabel ?? t('common.confirm')}
          </button>
        </div>
      </div>
    </div>
  );
}
